export const latin_num_ext = {
  validate: value => new RegExp(/^([a-zA-Z0-9-_,.]+)$/).test(value)
};
